import styled from 'styled-components';
import { desktop1440 } from '@nubank/nuds-web/styles/breakpoints';

const HeroWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;

  ${desktop1440`
    height: calc(100vh - 80px);
  `}
`;

HeroWrapper.displayName = 'HeroWrapper';

export default HeroWrapper;
